import fetch from "@lib/fetch";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { currentDeveloperCacheKey } from "./constants";

export const disableMultiFactorAuth = reactQueryMutationAdapter(currentDeveloperCacheKey, async () => {
  return await fetch("/two-factor/disable", "POST");
});
